export const initialFormDataValues = {
  name: '',
  title: '',
  description: '',
  group_id: null,
  schema: [],
}
